module.exports = __webpack_public_path__ + "img/truncus.7ba963bd.png";